import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const EMPTY_STATE_CONTENT = {
  empty: {
    title: "No contacts yet",
    description:
      "Add your first customer or supplier to manage invoices, quotations and payments.",
    icon: "plus",
  },
  noResults: {
    title: "No contacts found",
    description:
      "Try another name, email or ABN, or clear your search and filters.",
    icon: "file",
  },
};

export default function ContactEmptyState({ canCreate, variant }) {
  const content = EMPTY_STATE_CONTENT[variant];

  return (
    <div className={`contacts-empty-state contacts-empty-state--${variant}`}>
      <div className="contacts-empty-icon" aria-hidden="true">
        <span className={`contacts-empty-icon__asset is-${content.icon}`} />
      </div>

      <div className="contacts-empty-copy">
        <h3 className="contacts-empty-title">{content.title}</h3>
        <p className="contacts-empty-desc">{content.description}</p>
      </div>

      <div className="contacts-empty-actions">
        {canCreate && (
          <Link to="/contacts/addContact" className="contacts-empty-primary">
            {variant === "empty" ? "Add contact" : "Create Contact"}
          </Link>
        )}
        {variant === "empty" && (
          <Link to="/help" className="contacts-empty-secondary">
            Learn more
          </Link>
        )}
      </div>
    </div>
  );
}

ContactEmptyState.propTypes = {
  canCreate: PropTypes.bool,
  variant: PropTypes.oneOf(["empty", "noResults"]).isRequired,
};

ContactEmptyState.defaultProps = {
  canCreate: false,
};
